import { useTranslations } from "@zapier/i18n";
import { Icon } from "@zapier/zinnia-icons";
import { ServiceIconShell, Text } from "@zapier/design-system";
import { getAssetIcon, assetTypeToSentenceCase } from "@zapier/utils";
import { type LinkedAsset } from "./LinkedAssetsWarning";
import styles from "./UndeletableAssetsList.module.css";

interface UndeletableAssetsListProps {
  assets: LinkedAsset[];
}

/**
 * Plain, non-interactive rows for assets the viewer can't act on (e.g. no
 * permission to delete). Never links out and never borders the icon, even
 * when the asset type would otherwise resolve a URL.
 */
export function UndeletableAssetsList({ assets }: UndeletableAssetsListProps) {
  const tFallback = useTranslations("fallbacks");

  return (
    <ul className={styles.list}>
      {assets.map((asset) => (
        <li key={`${asset.type}:${asset.id}`} className={styles.item}>
          <ServiceIconShell size="small" hasBorder={false}>
            <Icon
              color="BrandOrange"
              name={getAssetIcon(asset.type)}
              size={14}
            />
          </ServiceIconShell>
          <Text>
            {asset.title ||
              tFallback("untitled-asset", {
                assetType: assetTypeToSentenceCase(asset.type),
              })}
          </Text>
        </li>
      ))}
    </ul>
  );
}
